import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { push } from '../../services/router-utils';
import { updateComment } from '../../actions/update-comment';
import goBack from '../../actions/go-back';
import { fetchPost } from '../../actions/fetch-post';
import { fetchComment } from '../../actions/fetch-comment';
import messages, { COMMENT_UPDATE } from '../../components/message/messages';
import withEnvironment from '../../hoc/with-environment';
import { getPostBySlug } from '../../selectors/post-selectors';
import { getComment } from '../../selectors/comment-selectors';
import AppLoaded from '../../components/app-loaded';
import NotFoundPage from '../error-page/not-found-page';
import CommentForm from '../../components/comment-form';
import CommentFormWrapper from '../../components/comment-form-wrapper';
import PostPageLayout from '../../components/post-page-layout';

export class CommentEditPage extends Component {
  static fetchData = ({ store, params: { categorySlug, postSlug, commentId }, search }) =>
    store
      .dispatch(fetchPost(postSlug))
      .then(post =>
        store.dispatch(
          fetchComment({
            postId: post._id,
            commentId,
          }),
        ),
      )
      .catch(error => {
        if (error.status === 401) {
          return store.dispatch(
            push({
              pathname: `/login${search}&redirect=/${categorySlug}/${postSlug}`,
            }),
          );
        } else {
          throw error;
        }
      });

  handleSubmit = values => {
    const { comment, updateComment, showMessage, goBack } = this.props;
    updateComment({ ...comment, ...values })
      .then(() => showMessage(messages[COMMENT_UPDATE].content(), messages[COMMENT_UPDATE].type))
      .then(goBack);
  };

  render = () => {
    const { comment, goBack } = this.props;

    if (!comment) {
      return <NotFoundPage />;
    }

    return (
      <PostPageLayout className="comment-edit-page">
        <CommentFormWrapper>
          <CommentForm initialValues={comment} onSubmit={this.handleSubmit} onCancel={goBack} />
        </CommentFormWrapper>
        <AppLoaded />
      </PostPageLayout>
    );
  };
}

CommentEditPage.propTypes = {
  comment: PropTypes.object,
  goBack: PropTypes.func.isRequired,
  showMessage: PropTypes.func,
  updateComment: PropTypes.func.isRequired,
};

const mapStateToProps = (state, { params: { postSlug, commentId } }) => {
  const post = getPostBySlug(state, postSlug);
  return {
    comment: getComment(state, commentId, post._id),
  };
};

const mapDispatchToProps = {
  goBack,
  updateComment,
};

export default _.flowRight(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withEnvironment({ showMessage: 'showMessage' }),
)(CommentEditPage);
